import * as React from 'react';
import { classes, style } from 'typestyle';
import ButtonAtom from '../../atoms/button/ButtonAtom';
import { alignmentSet, ButtonAlignment } from '../../../styles/button';
import { getButtonStyles, getStateDependentValues, getButtonSizeStyle } from './helpers';
const styles = getButtonStyles();
const Button = (props) => {
    const { onClick, className, small = false, naked = false, raised = false, alignment = ButtonAlignment.Center, fullWidth, type, disabled = false, pending = false, done = false, tabIndex, } = props;
    const { styleType, icon, title } = getStateDependentValues(props);
    const sizeStyle = getButtonSizeStyle({ icon, title, naked, small });
    return (React.createElement(ButtonAtom, { title: title, icon: icon, type: type, className: classes('ta-contained-btn', styleType && `ta-btn-style-${styleType}`, styleType && styles[styleType], raised && raisedStyle, sizeStyle, fullWidth && fullWidthStyle, style({ justifyContent: alignmentSet[alignment] }), className), disabled: disabled || pending || done, onClick: onClick, tabIndex: tabIndex }));
};
export default Button;
const raisedStyle = style({
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.35)',
});
const fullWidthStyle = style({
    width: '100%',
});
//# sourceMappingURL=Button.js.map